import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 5.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0","key":"svg-0"}],["path",{"d":"M6 3h5v5h-5l0 -5","key":"svg-1"}],["path",{"d":"M11 11v10a5 5 0 0 1 -.217 -9.995l.217 -.005","key":"svg-2"}]]

const IconBrandRadixUi = createReactComponent('outline', 'brand-radix-ui', 'BrandRadixUi', __iconNode);

export default IconBrandRadixUi;